import React from 'react';

import { CustomReportsTool } from './custom-report-tool';
export const AdminCustomReports = props => {
  return <CustomReportsTool isBuilder={false} isBulk={true} {...props} />;
};
